<template>
  <DroppableFileSelector
    ref="droppableFileSelector"
    v-loading="loading"
    v-bind="$attrs"
    class="droppable-image-selector"
    :accept="accept"
    :disabled="disabled || !canChange"
    @change="handleFileSelect"
  >
    <template v-if="imagePreview" v-slot="{ openFileSelector }">
      <div class="droppable-image-selector__preview">
        <div
          v-if="!disabled"
          class="droppable-image-selector__overlay"
          @click="openFileSelector"
        >
          <ElButton
            v-if="canChange"
            icon="el-icon-edit-outline"
            type="primary"
            circle
            @click.stop="openFileSelector"
          />

          <ElButton
            v-if="clearable"
            icon="el-icon-delete"
            type="danger"
            circle
            @click.stop="deleteSelectedFile"
          />
        </div>

        <img
          :src="imagePreview"
          alt=""
          class="droppable-image-selector__preview"
        />
      </div>
    </template>
  </DroppableFileSelector>
</template>

<script>
import DroppableFileSelector from './DroppableFileSelector';

export default {
  name: 'DroppableImageSelector',
  components: { DroppableFileSelector },
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    canChange: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: null,
    },
    accept: {
      type: String,
      default: '.jpg,.png,.jpeg',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localImage: null,
    };
  },
  computed: {
    imagePreview() {
      if (this.image) return this.image;
      return this.localImage ? URL.createObjectURL(this.localImage) : null;
    },
  },
  methods: {
    handleFileSelect(images = []) {
      if (!images.length) return;

      this.localImage = images[0];
      this.$emit('change', this.localImage);
    },
    deleteSelectedFile() {
      this.localImage = null;
      this.$emit('change', null);
    },
    reset() {
      this.localImage = null;
      this.$refs.droppableFileSelector?.reset();
    },
  },
};
</script>

<style lang="scss">
.droppable-image-selector {
  $block: &;
  height: inherit;

  &__preview {
    width: 100%;
    overflow: hidden;

    img {
      width: auto;
      height: 100%;
    }

    &:hover {
      #{$block}__overlay {
        pointer-events: all;
        opacity: 1;
      }
    }
  }

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    border-radius: 5px;
    background: rgba($lb-color-primary, 0.2);
    color: $lb-white;
    font-size: 3rem;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    @include breakpoint(medium down) {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
